const menu = $(".js-menu");
const overlay = $(".js-overlay");
const catalogParent = $(".js-openCatalog").parent();

function showMenu() {
  menu.addClass("menu_open");
  overlay.addClass("is_show");
}

function hideMenu() {
  menu.removeClass("menu_open");
  overlay.removeClass("is_show");
  catalogParent.removeClass("is_active");
  $(".header__bottom-list .is_active").removeClass("is_active");
}

$(document).on("click", ".js-openMenu", function () {
  let _this = $(this),
    content = $("" + _this.data("menu") + "");

  if (_this.hasClass("js-openCatalog")) {
    $(".header__bottom-list .is_active").removeClass("is_active");

    if (!_this.parent().hasClass("is_active")) {
      _this.parent().addClass("is_active");

      content.addClass("is_open").siblings().removeClass("is_open");

      showMenu();
    } else {
      _this.parent().removeClass("is_active");

      content.removeClass("is_open").siblings().removeClass("is_open");

      hideMenu();
    }
  } else {
    _this.parent().addClass("is_active").siblings().removeClass("is_active");

    catalogParent.removeClass("is_active");

    content.addClass("is_open").siblings().removeClass("is_open");

    showMenu();
  }
});

$(document).on("click", ".js-overlay", function () {
  hideMenu();
});

$(document).on("click", function (e) {
  var div = $(".js-openMenu"); // тут указываем ID элемента
  var div2 = $(".js-menu");

  // если клик был не по нашему блоку и не по его дочерним элементам
  if (
    !div.is(e.target) &&
    div.has(e.target).length === 0 &&
    !div2.is(e.target) &&
    div2.has(e.target).length === 0
  ) {
    hideMenu();
  }
});

$(document).keydown(function (e) {
  // ESCAPE key pressed
  if (e.keyCode == 27) {
    hideMenu();
  }
});
